export default __webpack_public_path__ + "static/media/close-circle.39d2d502.svg";